import { useAuth } from '../context/AuthContext'

/** Returns true only when the logged-in user has the 'superadmin' role. */
export function useIsAdmin(): boolean {
  const { isRole } = useAuth()
  return isRole('superadmin')
}
